import { useSchematicBuilderContext } from "../../SchematicBuilderContext";
import { preventDrag } from "../../util/preventDrag";

export function ChildMarker() {
  const { schematicKinds, useSchematic, setSchematic } =
    useSchematicBuilderContext();
  const kind = useSchematic((schematic) => schematic.kind);
  const collapsed = useSchematic((schematic) => schematic.collapsed);
  const Builder = schematicKinds.get(kind)?.builder;

  return Builder ? (
    <button
      type="button"
      className="builder-child-marker"
      title={collapsed ? "Expand" : "Collapse"}
      onClick={() =>
        setSchematic((schematic) => ({
          collapsed: !schematic.collapsed,
        }))
      }
      {...preventDrag}
    >
      {collapsed ? "▸" : "▾"}
    </button>
  ) : (
    <span className="builder-child-marker">•</span>
  );
}
